module.exports = __webpack_public_path__ + "img/bubble-paragraphs.7c1f438e.webp";